document.addEventListener('DOMContentLoaded', function () {
    const widthInput = document.querySelector('.calculator__width-input');
    const heightInput = document.querySelector('.calculator__height-input');
    const spaceCalculationResult = document.querySelector('.calculator__result');

    const productDimensions = productSize.split('x').map((item) => item.trim());

    const space = parseFloat(productDimensions[0]) * parseFloat(productDimensions[1]);
   
    function updateResult() {
        const product = parseFloat(widthInput.value) * parseFloat(heightInput.value);
        const calculatedValue = Math.max(Math.ceil(product / space), 1);
        if (!isNaN(calculatedValue)) {
            productUnit[productUnit.length - 2] = calculatedValue.toString();

            spaceCalculationResult.textContent = productUnit.join(' ');
        }
        else {
            spaceCalculationResult.textContent = '';
        }
    }

    widthInput.addEventListener('input', updateResult);
    heightInput.addEventListener('input', updateResult);

});